import { IPartialReducer } from "../../../../core/core-redux/reduxTypes";
import { Wfs3dLayersState } from "../../wfs3dLayers.reducer";

export const wfs3dLayerLoadingPartialReducer: IPartialReducer<Wfs3dLayersState> = () => {
    return {
        loading: true,
    };
};
